import styled, { useTheme } from "styled-components";
import closeMsgImg from "../../../assets/img/closeModal.svg";
import Text from "../Text";

const StyledModal = styled("div")(({ theme }) => ({
  position: "fixed",
  zIndex: 1102,
  right: 0,
  top: 0,
  left: 0,
  bottom: 0,
  width: "100%",
  height: "100%",
  overflow: "auto",
  display: "none",
  backgroundColor: theme.color.background,
}));

const ModalContent = styled("div")(({ theme, noMargin }) => ({
  backgroundColor: theme.color.white,
  opacity: 1,
  margin: "auto",
  padding: noMargin ? 0 : 5,
  borderRadius: 4,
  textAlign: "center",
  display: "flex",
  alignItems: "center",
}));

const Modal = ({ children, show, onClose, title, note, noMargin = false }) => {
  const theme = useTheme();

  if (show === false) {
    return null;
  }

  return (
    <StyledModal onClick={() => onClose()} style={{ display: "flex" }}>
      <ModalContent onClick={(e) => e.stopPropagation()} noMargin={noMargin}>
        <div style={{ display: "flex", flexDirection: "column", margin: noMargin ? 0 : 20 }}>
          {!!title && (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: noMargin ? "40px 20px 20px 20px" : 0,
                }}
              >
                <div>
                  {!!title && <Text.H1 color={theme.color.red}>{title.toUpperCase()}</Text.H1>}
                  {!!note && (
                    <Text
                      size={16}
                      color={theme.color.lightText}
                      style={{ marginInlineStart: "20px" }}
                    >
                      {note}
                    </Text>
                  )}
                </div>
                <img
                  onClick={() => onClose()}
                  alt="closeMsgImg"
                  src={closeMsgImg}
                  style={{
                    width: 28,
                    height: 28,
                    margin: 0,
                    marginInlineStart: 20,
                    marginBottom: 7,
                    cursor: "pointer",
                  }}
                />
              </div>
              <div style={{ margin: noMargin ? "40px 20px 20px 20px" : 0 }}>
                <hr style={{ marginTop: 20, marginBottom: 30 }}></hr>
              </div>
            </div>
          )}
          <div>{children}</div>
        </div>
      </ModalContent>
    </StyledModal>
  );
};

export default Modal;
